import axios from "axios";

export default {
  state: {
    user: {
      name: '',
      email: ''
    }
  },
  getters: {
    currentUser(state) {
      return state.user;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    async fetchUser(ctx) {
      const response = await axios.get("me", {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      });
      ctx.commit("setUser", response.data);
    }
  }
};
